import { InjectionToken } from "@angular/core";


export interface IKeystoneAuthStorage {
  getToken() : Promise<string>;
  setToken(token: string);
  getTokenExpiration() : Promise<number>;
  setTokenExpiration(tokenExpiration: number);
  getRefreshToken(): Promise<string>;
  setRefreshToken(refreshToken: string);
  getUid(): Promise<string>;
  setUid(uid: string);
}

export const KeystoneAuthStorage = new InjectionToken('KEYSTONE_AUTH_STORAGE');

export class DefaultKeystoneAuthStorage implements IKeystoneAuthStorage {

  getToken(): Promise<string> {
    return Promise.resolve(localStorage.getItem('keystone-auth-token'));
  }

  setToken(token: string) {
    return localStorage.setItem('keystone-auth-token', token);
  }

  getTokenExpiration(): Promise<number> {
    return Promise.resolve(
      +localStorage.getItem('keystone-auth-expiration')
    );
  }

  setTokenExpiration(tokenExpiration: number) {
    return localStorage.setItem('keystone-auth-expiration', tokenExpiration + '');
  }

  getRefreshToken(): Promise<string> {
    return Promise.resolve(localStorage.getItem('keystone-auth-refresh'));
  }

  setRefreshToken(refreshToken: string) {
    return localStorage.setItem('keystone-auth-refresh', refreshToken);
  }

  getUid(): Promise<string> {
    return Promise.resolve(localStorage.getItem('keystone-auth-uid'));
  }

  setUid(uid: string) {
    return localStorage.setItem('keystone-auth-uid', uid);
  }

}


// WEBPACK FOOTER //
// ./src/keystone-http/keystone-auth.storage.ts